import { BundlePriceProps } from 'templates/Bundles/BundlePrice/types';
import { useEffect, useState } from 'react';
import { formattingNumber } from 'utils';
import { PokerFaceSpecialOfferButton } from './style';
import { ActualPrice } from 'templates/Bundles/BundlePrice/ActualPrice';

const PokerFaceSpecialOfferPrice = ({
  price,
  buttonColor,
  borderColor,
  buttonTextColor,
  isFree,
  buttonText = 'Collect',
}: BundlePriceProps) => {
  const [finalPrice, setFinalPrice] = useState('');
  const [priceBeforeDiscount, setPriceBeforeDiscount] = useState('');

  useEffect(() => {
    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      true,
    );
    if (price.strokedPriceInCents) {
      const formattedPriceBeforeDiscount = formattingNumber(
        price?.strokedPriceInCents,
        price,
        price.isCents,
        price.multiplier,
        true,
      );
      setPriceBeforeDiscount(formattedPriceBeforeDiscount);
    }
    setFinalPrice(formattedPrice);
  }, [price]);

  return (
    <PokerFaceSpecialOfferButton
      backgroundColor={buttonColor}
      textColor={buttonTextColor}
      borderColor={borderColor}
      direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
    >
      <div className="container">
        {isFree ? (
          <span>{buttonText}</span>
        ) : (
          <ActualPrice
            finalPrice={finalPrice}
            priceBeforeDiscount={priceBeforeDiscount}
            price={price}
            textShadow="0 2px 1px #004100"
          />
        )}
      </div>
    </PokerFaceSpecialOfferButton>
  );
};

export default PokerFaceSpecialOfferPrice;
